import type { PathPowerUpPlacement } from '../../config/powerUpPositions'
import type { TrackController } from '../track/trackController'
import { lanePositions } from '../../config/constants'

const POWER_UP_HITBOX = { x: 0.35, z: 0.55 }
const PLAYER_HITBOX_HALF_X = 0.2

export type PowerUpHitData = {
    index: number
    trackPosition: number
    laneX: number
    collected: boolean
}

export type PowerUpCollisionData = {
    powerUps: PowerUpHitData[]
}

export function buildPowerUpCollisionData(
    placements: readonly PathPowerUpPlacement[],
    trackController: TrackController,
): PowerUpCollisionData {
    const powerUps: PowerUpHitData[] = placements.map((placement, index) => ({
        index,
        trackPosition: placement.position,
        laneX: lanePositions[placement.track] ?? 0,
        collected: false,
    }))

    return { powerUps }
}

export function checkPowerUpCollision(
    playerTrackPosition: number,
    playerLaneX: number,
    collisionData: PowerUpCollisionData,
): number {
    for (const powerUp of collisionData.powerUps) {
        if (powerUp.collected) continue

        const trackDelta = Math.abs(playerTrackPosition - powerUp.trackPosition)
        if (trackDelta > POWER_UP_HITBOX.z) continue

        const laneDelta = Math.abs(playerLaneX - powerUp.laneX)
        if (laneDelta >= PLAYER_HITBOX_HALF_X + POWER_UP_HITBOX.x) continue

        return powerUp.index
    }

    return -1
}